import React from 'react'
import CheckIcon from '~/images/check-black.svg'
import { gettingDict } from '~helpers/constant'

export const Getting: React.FC = () => {
  const blocks = gettingDict['UZ']
  return (
    <div className='onlinepbx__partners__getting'>
      <div className='onlinepbx__container'>
        <h2 className='onlinepbx__partners__getting__header'>
          Что вы получаете
        </h2>
        <div className='onlinepbx__partners__getting__content'>
          {blocks.map(block => {
            return (
              <div className='onlinepbx__partners__getting__wrapper'>
                {
                  block.map(subblock => {
                    return (
                      <div
                        className='onlinepbx__partners__getting__block'
                        key={subblock.color}>
                        <div
                          className='onlinepbx__partners__getting__background'
                          style={{ background: subblock.color }} />
                        <CheckIcon className='onlinepbx__partners__getting__check' />
                        <div className='onlinepbx__partners__getting__description'>
                          <div className='onlinepbx__partners__getting__description__header'>
                            {subblock.header}
                          </div>
                          <div className='onlinepbx__partners__getting__description__text'>
                            {subblock.description}
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Getting
